/**
 * @file ppde页面
 * @author FengGuang(fengguang01@baidu.com)
 */
import {useEffect, useState} from 'react';
import {fetchGetPpdeMemberInfo} from '../../api/pages/ppdeMemberApi';
import {IMemberInfo} from './types';

const getMemberName = () => {
    const params = new URLSearchParams(window.location.search.slice(1));
    return params.get('n') || '';
};

// 预请求
let preRequest: any = {
    fetchGetPpdeInfo: fetchGetPpdeMemberInfo(getMemberName())
};

const usePpdeMDHooks = () => {
    const [memberInfo, setMemberInfo] = useState<IMemberInfo>(() => {
        return {
            works: Array(4).fill({})
        };
    });

    useEffect(() => {
        (async () => {
            const fetchFunc = preRequest.fetchGetPpdeInfo || fetchGetPpdeMemberInfo(getMemberName());
            delete preRequest.fetchGetPpdeInfo;

            const res = await fetchFunc.catch(() => {
                // ignore
            });
            if (res) {
                const pageData = res.body.result?.pageData || {};
                const mi = pageData.memberInfo || {};
                const miWorks: any[] = Array.isArray(mi.works) ? mi.works : [];
                setMemberInfo({
                    company: mi.company,
                    position: mi.position,
                    entryTime: mi.entryTime,
                    goodField: mi.goodField,
                    works: miWorks.map((item) => ({
                        text: item.text,
                        link: item.link
                    })),
                    text: mi.text,
                    title: mi.title,
                    subtitle: mi.subtitle,
                    img: mi.img,
                    githubLink: mi.githubLink,
                    aiStudioLink: mi.aiStudioLink,
                    personalHomePage: mi.personalHomePage,
                    certificate: mi.certificate
                });
            }
        })();
    }, [setMemberInfo]);

    return {
        memberInfo
    };
};

export default usePpdeMDHooks;
